import { styled, Card, Box, Text } from '@/theme/index';

export const StyledServiceCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2, 4),
  borderRadius: theme.shape.borderRadius,
  justifyContent: 'center',
  alignContent: 'center',
  boxShadow: `0 0 0 1px ${theme.palette.grey[200]}`,
  position: 'relative',
}));

export const StyledText = styled(Text)`
  cursor: pointer;
  text-decoration: underline;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const ImageServiceContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  margin: 0 auto;
  margin-bottom: 12px;
`;

export const StyledServiceImage = styled('img')`
  max-width: 32px;
  max-height: 32px;
  object-fit: contain;
`;
